enum HeaderUtenteOperationEnum {
    Utente = "utente",
    Profilo = "profilo",
    Logout = "logout",
}

export default HeaderUtenteOperationEnum;
